import addToCartService from '../services/rbata.addToCartService';
import theLookService from '../services/rbata.theLookService';
import personalizedProductService from '../services/rbata.personalizedProductService';
import personalizeService from '../services/rbata.personalizeService';
import logger from '../utils/rbata.logger';
import notifyMeService from '../services/rbata.notifyMeService';
import detailPanel from "../pdp/rbata.detailpanel";

const completeTheLook = {
    $document: undefined,
    init() {
        this.$document = $(document);
        this.bulkPriceCorrect();
    },

    bindEvents() {
        /**
         * add to cart functionality. If no size is selected show an error message
         */
        this.$document.on('click', '.js-ctl__add-to-cart', (evt) => {
            evt.preventDefault();
            const currentTarget = evt.currentTarget;
            const dataset       = currentTarget.dataset;
            if (dataset.code === '') {
                theLookService.clearLocalErrorMessages(currentTarget).call(this);
                theLookService.renderLocalErrorMessages(currentTarget).call(this, [dataset.message]);
                return;
            }
            addToCartService.addToCart(dataset.url, dataset.code, theLookService.clearLocalErrorMessages(currentTarget),
                    theLookService.renderLocalErrorMessages(currentTarget));
        });

        /**
         * Update all related information on change of a size
         */
        this.$document.on('click', '.js-ctl__select-size', (evt) => {
            evt.preventDefault();
            const currentTarget = evt.currentTarget;

            personalizeService.getPersonalizedData().then((data) => {
                // exchange price only on logged in users
                if (data.loginState === '1') {
                    personalizedProductService.fetchPersonalizedProductDataRequest(currentTarget.dataset.code).then((data) => {
                        if (data.discountedPrice && data.oldPrice) {
                            currentTarget.setAttribute('data-discounted-price', data.discountedPrice.formattedValue);
                            currentTarget.setAttribute('data-old-price', data.oldPrice.formattedValue);
                        }
                        theLookService.performSizeChange(currentTarget);
                    }, (jqXHR) => {
                        logger.error(`${jqXHR.status} error in fetchPersonalizedProductDataRequest`);
                    });
                } else {
                    theLookService.performSizeChange(currentTarget);
                }
            }, (jqXHR) => {
                logger.error(`${jqXHR.status} error in getPersonalizedData`);
            });
        });

        /**
         * Delegate notifyMe
         */
        this.$document.on('click', '.js-ctl__notifyme', (evt) => {
            evt.preventDefault();
            const dataset = evt.currentTarget.dataset;
            if (dataset.code !== '') {
                notifyMeService.showNotifyMeModal(dataset.code);
            } else {
                theLookService.clearLocalErrorMessages(evt.currentTarget).call(this);
                theLookService.renderLocalErrorMessages(evt.currentTarget).call(this, [dataset.message]);
            }
        });
    },
    bulkPriceCorrect() {
        this.$document
            .find('.cms-complete-the-look__product')
            .each((index, element) => {
                personalizedProductService.fetchPersonalizedProductDataRequest(element.dataset.code).then((data) => {
                    // user is part of a customer price group
                    const $elem = $(element);
                    if (data.discountedPrice && data.oldPrice) {
                        $elem
                                .find('.tile__price')
                                .html(`<span>${data.discountedPrice.formattedValue}</span>
                                       <s class="tile__price--strike">${data.oldPrice.formattedValue}</s>`);
                    }
                    // check if product is restricted
                    if (data.availableForDeliveryCountry) {
                        $elem.find('.js-ctl__actions').removeClass('invisible');
                    } else {
                        $elem.find('.js-ctl__actions').addClass('d-none');
                        $elem.find('.js-ctl-restricted-panel').removeClass('d-none');
                    }
                    detailPanel.preselectFirstAvailableSize('.ctl__actions-size', '.js-ctl__select-size');
                }, (jqXHR) => {
                    logger.error(`${jqXHR.status} error in bulkPriceCorrect`);
                });
            });
    }
}

$(() => {
    if ($('#js-complete-the-look__container').length) {
        completeTheLook.init();
        completeTheLook.bindEvents();
    }
});

export default completeTheLook;
